export default __webpack_public_path__ + "static/media/fin-tech.40715822.svg";